/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { token } from '@atlaskit/tokens';

import { type RestrictionOptionType } from '../types';

const styles = cssMap({
	optionWrapper: {
		color: token('color.text'),
		font: token('font.body'),
	},
});

export const restrictionOptionFormatter: <
	Option extends RestrictionOptionType = RestrictionOptionType,
>(
	option: Option,
) => JSX.Element = <Option extends RestrictionOptionType = RestrictionOptionType>(
	option: Option,
) => {
	return (
		<Box xcss={styles.optionWrapper}>
			<Flex alignItems="center" gap="space.100">
				{option.icon}
				{option.label}
			</Flex>
		</Box>
	);
};
